<template>
  <!-- 事件设置
       @author: liuguisheng
       @date: 2019-10-16
   -->
  <div class="setting-item">
    <el-form-item label="关联设置">
      <!--事件配置列表 -->
      <div class="setting-item_event"
           v-for="(eventItem, eventKey) in eventSaveObject"
           :key="eventKey">
        <!-- 事件触发配置 -->
        <el-form-item style="margin-left: 10px" label="触发选项">
          <!-- 表单项触发事件的值设定:
            1. 表单项为选择类型，使用选择框设置触发事件值
            2. 表单项为输入类型，使用输入框设置触发事件值
            dev: 这里关联着事件触发配置中，当前表单项对应的配置
          -->
          <template v-if="isSelectType(formId)">
            <el-select 
              v-model="eventItem.triggerValue"
              placeholder="选择选项">
              <el-option
                v-for="item in getFormOptions(formId)"
                :key="item.value"
                :label="item.value"
                :value="item.label">
              </el-option>
            </el-select>
          </template>
          <template v-if="isInputType(formId)">
            <el-input v-model="eventItem.triggerValue" placeholder="请输入触发关键字"></el-input>
          </template>
          <!-- 其它事件关联表单项:
            1. 关联表单项
            2. 关联表单项触发事件的值
            3. 删除事件关联表单项
            dev: 这里关联着事件触发配置中，所有其它表单项配置
          -->
          <div class="add-contact" 
               v-for="(contactItem, index) in eventItem.emit"
               :key="index">
            <el-select v-model="contactItem.form" 
                       placeholder="请选择关联表单项"
                       filterable 
                       :filter-method="(filterStr) => selectFilterValue = filterStr"
                       @visible-change="arguments[0] || (selectFilterValue = '')"
                       @focus="focusEventId = eventKey">
              <el-option
                v-for="item in getFilterForm(eventKey, contactItem.form)"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!-- 关联表单项 触发事件值 -->
            <template v-if="isSelectType(contactItem.form)">
              <el-select v-model="contactItem.value" placeholder="选择选项">
                <el-option
                  v-for="item in getFormOptions(contactItem.form)"
                  :key="item.value"
                  :label="item.value"
                  :value="item.label">
                </el-option>
              </el-select>
            </template>
            <template v-if="isInputType(contactItem.formId)">
              <el-input v-model="contactItem.value" placeholder="请输入触发关键字"></el-input>
            </template>
            <!-- 关联表单项 删除按钮 -->
            <el-button type="danger" round
              @click="removeContactItem(eventKey, index)">
              删除该项</el-button>
          </div>
          <!-- 关联表单项 新增按钮  -->
          <el-button type="primary" round
            @click="addContactItem(eventKey)">
            添加关联项</el-button>
          <!-- 关联项 组合方式 -->
          <el-select 
            v-if="eventItem.emit.length > 0"
            v-model="eventItem.eventType" 
            placeholder="请选择组合方式">
            <el-option v-for="item in makeUpTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 事件监听配置:
          1. 事件监听表单项
          2. 表单项响应行为
        -->
        <el-form-item style="margin-left: 10px" label="关联选项">
          <el-select v-model="eventItem.on.form" 
                     placeholder="请选择目标表单项"
                     filterable 
                     :filter-method="(filterStr) => selectFilterValue = filterStr"
                     @visible-change="arguments[0] || (selectFilterValue = '')"
                     @focus="focusEventId = eventKey">
            <el-option
              v-for="item in getFilterForm(eventKey, eventItem.on.form)"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="eventItem.on.action" placeholder="请选择目标的出现方式">
            <el-option
              v-for="item in eventConfigList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 事件操作按钮:
          1. 删除事件按钮
          2. 保存事件按钮
         -->
        <div class="add-event_button">
          <el-button type="danger" 
                    @click="dialogManage(removeEvent).show(eventKey)">删除选项</el-button>
          <el-button type="primary" 
                    @click="submitEvent(eventKey)">确定添加</el-button>
        </div>
      </div>
      <div class="add-event_button">
        <el-button type="text" @click="addEvent">添加选项</el-button>
      </div>
    </el-form-item>
    <!-- 删除事件弹窗 -->
    <el-dialog title="删除关联"
              :visible.sync="removeEvent.visible"
              width="384px"
              plugin-name="ElLeave">
      <span slot="leave-title">确认删除该关联吗？</span>
      <span slot="leave-auxiliary">删除后该关联无法恢复！</span>
      <i slot="leave-icon" class="el-icon-erp-kulian"></i>
      <template slot="footer">
        <el-button type="primary" @click="submitRemoveEvent">确认</el-button>
        <el-button type="cancel" @click="dialogManage(removeEvent).hide()">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/** 配置数据 ::: 
 *  @param {Array<Object>} eventConfigList 事件行为字典表选择项
 *  @param {Array<Object>} makeUpTypeList 事件组合方式字典表
 */
import { eventConfigList, makeUpTypeList } from "@/assets/js/config_dictionary.js";
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级
 *  @mixin mixValueWatch value属性工具方法
 *  @function mapComputed 计算属性展开方法
 */
import { mixRiceIndexChild } from "@/mixins/rice_index/mix_rice_index_child.js";
import mixValueWatch from "@/mixins/common/mix_value_watch.js";
import { mapComputed } from "@/mixins/common/mix_value_watch.js";
/** 工具方法 ::: 
 *  @function Check 校验事件表单
 *  @function dialogDefaultConfig 获取对话框默认配置方法
 *  @function dialogManage 对话框管理者
 */
import Check from "@/utils/event_rule.js";
import { dialogDefaultConfig, dialogManage } from "@/utils/dialog_manage.js";


export default {
  mixins: [
    mixRiceIndexChild,
    mixValueWatch, 
  ],
  data() {
    return {
      // 字典数据: 事件行为、事件组合方式
      eventConfigList,
      makeUpTypeList,
      // 表单项类型分组
      formTypeGroup: {
        input: new Set(['input','textarea','datePicker','timePicker']),
        select: new Set(['radio','checkbox','select','switch']),
        button: new Set(['button'])
      },
      // 事件存储列表
      eventSaveObject: {},
      // 删除事件确认弹窗
      removeEvent: dialogDefaultConfig(),
      // 激活事件id
      focusEventId: "",
      // 表单项选项过滤值
      selectFilterValue: "",
    };
  },
  methods: {
    dialogManage,
    /** @name 添加事件
     *  @return { void }
     *  @author liuguisheng
     *  @version 2019-10-19
     */
    addEvent() {
      // 生成默认事件配置
      let eventConfig = this.makeEventConfig(this.formId);
      let eventId = this.eventEditConfigManager(eventConfig).getId();
      // 添加默认事件配置
      this.$set(this.eventSaveObject, eventId, eventConfig);
    },
    /** @name 删除事件
     *  @return { void }
     *  @author liuguisheng
     *  @version 2019-10-19
     */
    submitRemoveEvent() {
      // 要删除的事件id
      let eventId = dialogManage(this.removeEvent).data;
      // 调用工具方法删除事件配置
      this.eventConfigManager(eventId).deleteEvent();
      this.$delete(this.eventSaveObject, eventId);
      this.$message("删除成功！");
      // 关闭弹层
      dialogManage(this.removeEvent).hide();
    },
    /** @name 添加关联表单项
     *  @param {String} eventId 事件id
     *  @author liuguisheng
     *  @version 2019-10-22
     */
    addContactItem(eventId) {
      // 事件配置
      let eventConfig = this.eventSaveObject[eventId];
      // 事件添加新关联表单项
      this.eventEditConfigManager(eventConfig).addContact();
    },
    /** @name 删除关联表单项
     *  @param {String} eventId 事件id
     *  @param {String} index 关联项索引
     *  @author liuguisheng
     *  @version 2019-10-22
     */
    removeContactItem(eventId, index) {
      // 事件配置
      let eventConfig = this.eventSaveObject[eventId];
      // 删除指定索引的关联表单项配置
      this.eventEditConfigManager(eventConfig).removeContact(index);
    },  
    /** @name 提交事件
     *  @param { String } eventId 事件id
     *  @return { void }
     *  @author liuguisheng
     *  @version 2019-10-19
     */
    submitEvent(eventId) {
      // 取出组件内 事件配置
      let eventConfig = this.eventSaveObject[eventId];
      // 转换事件配置为提交格式
      let submitModel = this.eventEditConfigManager(eventConfig).transform();
      // 设置不需要校验的数组
      let unInclude = ['eventType','value'];
      // 实例化校验类开始进行事件验证
      let check = new Check()
      let result = check.checkObject( submitModel,unInclude )
      // 消息提示信息定义，如果验证失败提示，验证成功添加事件配置
      let tipMessage;
      if (!result) {
        tipMessage = {type: 'warning', message: '请将当前关联设置填写完整！'}
      } else {
        // 提交更新事件配置
        this.eventConfigManager(eventId).upsertEvent(submitModel);
        tipMessage = {type: 'success', message: '关联设置添加成功！'}
      }
      // 消息提示
      this.$message(tipMessage)

    },
    /** @name 获取事件表单选择项
     *  @param {String} eventId 事件id
     *  @param {String} formId 表单项id
     *  @return {Array} 关联、监听 表单项选择项 {label:表单项名称，value:表单项id}
     *  @author 王汝鹏
     *  @version 2019-10-23
     */
    getFilterForm(eventId, formId) {
      // 其他事件关联表单项选择项，返回已选择的表单项或者空
      if (eventId !== this.focusEventId) return formId ? [ this.formMapOptions.get(formId) ] : [];

      // 从所有表单项选择项中去除掉事件已经配置过的表单项选项
      let eventConfig = this.eventSaveObject[eventId];
      let formIds = this.eventEditConfigManager(eventConfig).getFormIds(); 
      let filterFormMap = new Map(this.formMapOptions);
      filterFormMap.delete(this.formId);
      for (let formId of formIds) { filterFormMap.delete(formId); }

      let maxLength = 20;
      let filterFormOptions = [];

      // 将当前已选表单项添加到选择项中
      if (formId) {
        let selectForm = this.formMapOptions.get(formId);
        if (selectForm && selectForm.label && selectForm.label.includes(this.selectFilterValue)) {
          filterFormOptions.push(selectForm);
        }
      }

      // 使用过滤内容过滤表单项选择项
      for (let [key, value] of filterFormMap) {
        let { label:formName } = value;
        if (formName && formName.includes(this.selectFilterValue)) filterFormOptions.push(value);
        if (filterFormOptions.length >= maxLength) break;
      }

      // 返回过滤后的表单选择项
      return filterFormOptions;
    },
    /** @name 获取表单项选择项
     *  @param {String} formId 表单项id
     *  @return {Array} 表单项选择项
     *  @author 王汝鹏
     *  @version 2019-10-22
     */
    getFormOptions(formId) {
      // 取出 表单项配置\基础配置\选择项配置
      let {baseOption} = this.formMap[formId] || {};
      let {options=[]} = baseOption || {};
      // 添加 任意值触发事件 选择项
      options = [{label:"*", value:"任意值"}, ...options];
      return options;
    },
    /** @name 获取表单项类型
     *  @param {String} formId 表单项id
     *  @return {String} 表单项类型
     *  @author 王汝鹏
     *  @version 2019-10-22
     */
    getFormType(formId) {
      // 获取表单项配置，获取表单项类型
      let {type} = (this.formMap[formId] && this.formMap[formId].node) || {};
      return type || "";
    },
    /** @name 是否为选择框
     *  @param {String} formId 表单项id
     *  @return {Boolean} 
     *  @author 王汝鹏
     *  @version 2019-10-22
     */
    isSelectType(formId) {
      // 获取表单项类型，判断是否为选择类型
      let type = this.getFormType(formId);
      return this.formTypeGroup.select.has(type);
    },
    /** @name 是否为输入框
     *  @param {String} formId 表单项id
     *  @return {Boolean} 
     *  @author 王汝鹏
     *  @version 2019-10-22
     */
    isInputType(formId) {
      // 获取表单项类型，判断是否为输入类型
      let type = this.getFormType(formId);
      return this.formTypeGroup.input.has(type);
    },
  },
  computed: {
    /** @name 事件设置
     *  @description 将 event 字段映射到当前 event 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-09-20
     */
    ...mapComputed({
      // {event:表单项事件配置, formType:表单项类型, formId:表单项id, formOption:表单项选择项}
      event: { attr:"event" },
      formType: { attr:"type", parent:i=>i.node },
      formId: { attr:"selfId", parent:i=>i.node },
      formOption: { attr:"options", parent:i=>i.baseOption }
    }),
    /** @name 表单项字典
     *  @description 这里是所有表单项的 id+名称 的Map字典, 用于选择 关联项或监听者 使用
     *  @return {Map<String,String>}
     *  @author 王汝鹏
     *  @version 2019-10-22
     */
    formMapOptions() {
      return new Map(Object.keys(this.formMap).filter(formId => {
        let { node } = this.formMap[formId] || {};
        let { type } = node || {};
        return type !== 'gridColumn';
      }).map(formId => {
        // 这里没有customName会显示一大长串的id，应该添加默认的其它名称
        let formName = this.formMap[formId].baseOption.customName || "";
        return [formId, {label:formName, value:formId}];
      }))
    },
    /** @name 事件配置
     *  @author 王汝鹏
     *  @version 2019-10-20
     */
    eventConfig() {
      // 取出触发事件id列表
      let { emit } = this.event;
      // 事件配置 {eventId: Object}
      let result = {};
      // 格式化事件配置数据结构
      // 一个表单项有多个事件配置
      emit.map(eventId => {
        // 转换为事件配置的事件格式
        let eventConfig = this.eventConfigManager(eventId).transform(this.formId);
        // 更新事件表单项配置
        result[eventId] = eventConfig;
      })
      return result;
    }
  },
  watch: {
    /** @name 监听表单项事件配置
     *  @description 表单项配置发生变化，更新组件内部事件配置数据，因为事件配置不是实时响应的，这样也避免了数据的错误修改变化更新元配置。
     *  @author 王汝鹏
     *  @version 2019-10-27
     */
    eventConfig: {
      handler: function(newValue) { this.eventSaveObject = newValue; },
      immediate: true,
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingEvent.vue